/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Typography } from '@mui/material';
import { BrowserView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';


const Team = () => {

    const { classes } = useStyles();
    const { t } = useTranslation()
    return (
        <>
            <main>
                <BrowserView>

                    <Grid container className={classes.container}>
                        <Grid item xs={12} sm={12} md={12} style={{ margin: '30px' }}>
                            <Typography variant="h2" align="center">
                                {t('titles:OurCEOandFounder')}

                            </Typography>
                            <div className={classes.sectionTitleBorder}></div>
                            <Typography variant="h3" align="center" style={{ margin: '10px', color: "#748494", lineHeight: '1.75' }} paragraph>
                                Enterprise Applications are transitioning to Multi-Enterprise Applications using Distributed Ledger Technologies. Belltane is proud to be an industry-leading supplier of the next generation of business applications and services.                        </Typography>

                            <Grid container spacing="4" >


                                <Grid item xs={12} sm={12} md={12}>
                                    <Carousel
                                        showArrows={true}
                                        showDolts={false}

                                        infiniteLoop={true}
                                        showThumbs={false}
                                        showStatus={false}
                                        autoPlay={true}
                                        interval={6100}>
                                        <div style={{ backgroundColor: 'transparent' }}>

                                            <div className="myCarousel">
                                                <Typography variant="h2">James Worthington</Typography>
                                                <Typography variant="h2" style={{ lineHeight: '1.7', marginBottom: '15px' }}>CEO & Founder</Typography>

                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                                                    James has focused on the creation, capture, collection, dissemination, consumption, manipulation, and utilization of data to make substantial bottom-line contributions to successful data-driven organizations. He has held a variety of internal, external, and independent business and technical positions including

                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                                                    Director of Materials Management for an acute care healthcare facility,

                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7' }}>Director of Enterprise Analytics and Reporting Strategy for an international IT consulting organization,
                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>IT Solution Architect for one of the world’s most recognizable media companies,
                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>and

                                                    Senior Engineer for the inventor of multi-dimensional database technology.
                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>His strong functional, financial, operational, and technical background and capabilities has enabled him to deliver data solutions and provide exceptional business value to a diverse portfolio of startups and Fortune 500 companies spanning many verticals, including healthcare, media, software, life sciences, financial services, manufacturing, food services, energy, and apparel. He now imagines, designs, creates, and implements transformative Blockchain and DLT technologies for a wide range of customers, industries, geographies, and business needs.

                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>Specialties: Solution expert in all things Hyperledger, Blockchain, Digital Assets, Tokenomics, Data, IoT, ERP, BI, DW, ETL, EPM, Essbase, RDBMS, and much more.

                                                </Typography>
                                                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>When he gets a few minutes he continues to study Scottish fiddle, philology and languages, and the life-cycle of cultures and civilizations.


                                                </Typography>
                                            </div>
                                        </div>

                                    </Carousel>

                                </Grid>


                            </Grid>
                        </Grid>
                    </Grid>
                </BrowserView>

            </main>
        </>
    );
}


const useStyles = makeStyles({ "name": { Team } })((theme) => ({
    
    
    
 
     
    container: {
        maxHeigh: '500px!important',
        display: 'contents!important',
        margin: '50px!important',
        zIndex: '1',
        position: 'relative',
        minHeight: '300px!important',
        height: '500px!important',
        padding: '50px!important',


    },
    
    sectionTitleBorder: {
        width: '100px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',
        marginBottom: '30px',

    } 
}));

export default Team;